/**
 * This is a hook that provides a reusable way to send Google Analytics (gtag) events, such as
 * conversion tracking.
 *
 * This hook should be used in components where we want to track specific user actions using the
 * global `gtag` function (already included in index.html in the booking app).
 *
 * Example usage:
 *   const { sendEvent } = useGtagEvent();
 *   sendEvent('conversion', { send_to: 'AW-XXXX/XXXXX' });
 */

import { useCallback } from 'react';

type GtagFunction = (
  command: 'config' | 'event' | 'js',
  targetId: string,
  config?: Record<string, unknown>,
) => void;

export function useGtagEvent() {
  const sendEvent = useCallback((event: string, config?: Record<string, unknown>) => {
    const gtag = (window as unknown as { gtag?: GtagFunction }).gtag;

    if (typeof gtag === 'function') {
      gtag('event', event, config);
    } else {
      console.warn('gtag not available on window');
    }
  }, []);

  return { sendEvent };
}
